import { Routes } from '@angular/router';

import { roles } from '@shared/constants';
import { ClientApps } from '@shared/models';
import { agencyCodeGuard, authorizeGuard, redirectRootGuard, roleGuard, ssoUserGuard } from '@shared/services/guards';

export const routes: Routes = [
  { path: 'products/outcome', redirectTo: 'ignite/products/outcome', pathMatch: 'full' },
  { path: 'property/outcome', redirectTo: 'ignite/property/outcome', pathMatch: 'full' },
  { path: 'ignite/outcome', redirectTo: 'ignite/affordability/outcome', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent),
    canActivate: [authorizeGuard, roleGuard, redirectRootGuard],
    data: { roles: [roles.broker, roles.staff, roles.ignite, roles.mortgageClub] },
  },
  {
    path: 'smartrfit',
    redirectTo: 'ignite',
  },
  {
    path: 'ignite',
    loadChildren: () => import('./ignite/ignite.module').then((m) => m.IgniteModule),
    data: { client: ClientApps.ClubHub },
  },
  {
    path: 'procfee',
    loadChildren: () => import('./proc-fee/proc-fee.module').then((m) => m.ProcFeeModule),
    canActivate: [authorizeGuard, agencyCodeGuard],
    data: { client: ClientApps.ClubHub },
  },
  {
    path: 'mi',
    loadComponent: () => import('./mi/mi-generic/mi-generic.component').then(m => m.MiGenericComponent),
    canActivate: [authorizeGuard, roleGuard],
    data: { roles: [roles.broker, roles.brokerMi] },
  },
  {
    path: 'mi/integration',
    loadComponent: () => import('./mi/mi-integration/mi-integration.component').then(m => m.MiIntegrationComponent),
    canActivate: [authorizeGuard, roleGuard],
    data: { roles: [roles.broker, roles.brokerIntegrationMi] },
  },
  {
    path: 'mi/key-partner',
    loadComponent: () => import('./mi/mi-key-partner/mi-key-partner.component').then(m => m.MiKeyPartnerComponent),
    canActivate: [authorizeGuard, roleGuard],
    data: { roles: [roles.broker, roles.brokerNewKeyPartnerMI] },
  },
  {
    path: 'mi/executive-market-summary',
    loadComponent: () => import('./mi/mi-executive-summary/mi-executivesummary.component').then(m => m.MiExecutiveSummaryComponent),
    canActivate: [authorizeGuard, roleGuard],
    data: { roles: [roles.brokerPaidMI, roles.executiveMarketSummaryMI]},
  },
  {
    path: 'mi/broker-ignite',
    loadComponent: () => import('./mi/mi-broker/mi-broker.component').then(m => m.MiBrokerComponent),
    canActivate: [authorizeGuard, roleGuard],
    data: { roles: [roles.brokerPaidMI, roles.brokerIgniteMI]},
  },
  {
    path: 'contact',
    loadComponent: () => import('@shared/pages/contact-page/contact-page.component')
      .then(m => m.ContactPageComponent),
  },
  {
    path: 'loginexternal',
    loadComponent: () => import('@clubhub/components/login-external/external-login.component')
      .then(m => m.ExternalLoginComponent),
  },
  {
    path: 'documentpreferences',
    loadComponent: () => import('@clubhub/components/document-preferences-page/document-preferences-page.component')
      .then(m => m.DocumentPreferencesPageComponent),
  },
  {
    path: 'productpreferences',
    loadComponent: () =>
      import('@clubhub/components/user-custom-product-settings-page/user-custom-product-settings-page.component')
        .then(m => m.UserCustomProductSettingsPageComponent),
  },
  {
    path: 'filterpreferences',
    loadComponent: () => import('@clubhub/components/filter-preferences-page/filter-preferences-page.component')
      .then(m => m.FilterPreferencesPageComponent),
  },
  {
    path: 'firmdetails',
    loadComponent: () => import('@clubhub/components/firm-details-page/firm-details-page.component')
      .then(m => m.FirmDetailsPageComponent),
  },
  {
    path: 'managetwofactorauthentication',
    loadComponent: () => import('@clubhub/components/manage-two-factor-auth-page/manage-two-factor-auth-page.component')
      .then(m => m.ManageTwoFactorAuthPageComponent),
    canActivate: [authorizeGuard, ssoUserGuard],
  },
  {
    path: 'error',
    loadComponent: () => import('@shared/pages/error-page/error-page.component').then(m => m.ErrorPageComponent),
  },
  {
    path: '**', redirectTo: '' },
];
